export function SearchInput({
  value,
  onChange,
  placeholder = '',
  inline = false,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /** When true, removes outer margin so it sits flush inside a parent container */
  inline?: boolean;
}) {
  return (
    <div
      className={`flex items-center ${inline ? '' : 'mx-5 mb-5'}`}
      style={{
        height: 48,
        borderRadius: 100,
        backgroundColor: 'var(--t-surface)',
        paddingLeft: 16,
        paddingRight: 12,
        gap: 10,
      }}
    >
      {/* Search icon */}
      <div className="shrink-0 flex items-center justify-center" style={{ color: 'var(--t-text-secondary)' }}>
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
          <circle cx="8.5" cy="8.5" r="6.25" stroke="currentColor" strokeWidth="1.4" />
          <path d="M13.5 13.5l4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </div>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 min-w-0 focus-visible:outline-none"
        style={{
          height: '100%',
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          color: 'var(--t-text)',
          fontSize: 14,
          backgroundColor: 'transparent',
        }}
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="shrink-0 flex items-center justify-center"
          style={{ width: 20, height: 20 }}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 2l8 8M10 2l-8 8" stroke="var(--t-text-secondary)" strokeWidth="1.4" strokeLinecap="round" />
          </svg>
        </button>
      )}
    </div>
  );
}
